import { render, staticRenderFns } from "./ModalDetailsInsuranceQuotation.vue?vue&type=template&id=6393b259"
import script from "./ModalDetailsInsuranceQuotation.vue?vue&type=script&lang=js"
export * from "./ModalDetailsInsuranceQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports